/** @format */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { PaginationVariant } from '@toucan/client/shared/components/pagination';

import { CarouselBase } from './base';
import { styles } from './modal.styles';
import { CarouselModalProps, CarouselVariant } from './types';

export const DEFAULT_TEST_ID = 'carousel-modal';

const StyledCarouselModal = styled(CarouselBase)`
    ${styles}
`;

export const CarouselModal: FunctionComponent<CarouselModalProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}) => {
    const paginationHeight = 14; // ≈ pagination height
    const heightOffset = paginationHeight + (otherProps.note ? 5 : 0);

    return (
        <StyledCarouselModal
            {...otherProps}
            data-testid={dataTestId}
            maxSlideHeight={`calc(100vh - ${heightOffset}rem)`}
            variant={CarouselVariant.MINIMAL}
            paginationVariant={PaginationVariant.THUMBNAIL}
            showPagination
        />
    );
};
